import { APP_CONFIG } from 'app-config';

import { ChainNetwork } from './chains.types';
import { COSMOS_CHAINS_LIST } from './cosmos/cosmos.assets';
import { CosmosChainId, CosmosChainInfo } from './cosmos/cosmos.types';

export const CHAIN_CONFIG_LIST: Record<
  ChainNetwork,
  {
    restUrl: string;
    cosmosHubChainId: CosmosChainId;
    elysChainId: CosmosChainId;
    nobleChain: CosmosChainId;
    axelarChainId: CosmosChainId;

    edenValidator: string;
    edenBoostValidator: string;

    walletConnectProjectId: string;

    cctpContractAddress: string;
    usdcEthereumAddress: string;
  }
> = {
  devnet: {
    restUrl: 'https://rest.devnet.elys.network',
    cosmosHubChainId: 'provider',
    elysChainId: 'elysdevnet-1',
    nobleChain: 'grand-2',
    axelarChainId: 'axelar-testnet-lisbon-3',

    edenValidator: 'elysvaloper1gnmpr8vvslp3shcq6e922xr0uq4aa2w5gdzht0',
    edenBoostValidator: 'elysvaloper1wajd6ekh9u37hyghyw4mme59qmjllzuyaceanm',

    walletConnectProjectId: '4b90f61c1ed7f697d39c58af22dbf3fc',

    cctpContractAddress: '0x1ae045d99236365cbdc1855acd2d2cfc232d04d1',
    usdcEthereumAddress: '0x07865c6E87B9F70255377e024ace6630C1Eaa37F',
  },
  testnet: {
    restUrl: 'https://rest.testnet.elys.network',
    cosmosHubChainId: 'provider',
    elysChainId: 'elysicstestnet-1',
    nobleChain: 'grand-1',
    axelarChainId: 'axelar-testnet-lisbon-3',

    edenValidator: 'elysvaloper1gnmpr8vvslp3shcq6e922xr0uq4aa2w5gdzht0',
    edenBoostValidator: 'elysvaloper1wajd6ekh9u37hyghyw4mme59qmjllzuyaceanm',

    walletConnectProjectId: '4b90f61c1ed7f697d39c58af22dbf3fc',

    cctpContractAddress: '0x1ae045d99236365cbdc1855acd2d2cfc232d04d1',
    usdcEthereumAddress: '0x07865c6E87B9F70255377e024ace6630C1Eaa37F',
  },
  // TODO: Set me up
  mainnet: {
    restUrl: 'https://rest.elys.network',
    cosmosHubChainId: 'cosmoshub-4',
    elysChainId: 'elys-1',
    nobleChain: 'noble-1',
    axelarChainId: 'axelar-dojo-1',

    edenValidator: 'elysvaloper1gnmpr8vvslp3shcq6e922xr0uq4aa2w5gdzht0',
    edenBoostValidator: 'elysvaloper1wajd6ekh9u37hyghyw4mme59qmjllzuyaceanm',

    walletConnectProjectId: '69fc438a38f00f90bfa7097e2b9c495a',

    cctpContractAddress: '0xbd3fa81b58ba92a82136038b25adec7066af3155',
    usdcEthereumAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  },
};

export const CHAIN_CONFIG = CHAIN_CONFIG_LIST[APP_CONFIG.CHAIN_NETWORK as ChainNetwork];
//

const findChain = (chainId: CosmosChainId) =>
  COSMOS_CHAINS_LIST.find(
    chain => chain.chainId === chainId,
  ) as CosmosChainInfo;

export const COSMOS_HUB_CHAIN = findChain(CHAIN_CONFIG.cosmosHubChainId);
export const ELYS_CHAIN = findChain(CHAIN_CONFIG.elysChainId);
export const NOBLE_CHAIN = findChain(CHAIN_CONFIG.nobleChain);
export const AXELAR_CHAIN = findChain(CHAIN_CONFIG.axelarChainId);

if (!COSMOS_HUB_CHAIN) {
  throw new Error('Cosmos Hub chain not found');
}

if (!ELYS_CHAIN) {
  throw new Error('Elys chain not found');
}

if (!NOBLE_CHAIN) {
  throw new Error('Noble chain not found');
}

if (!AXELAR_CHAIN) {
  throw new Error('Axelar chain not found');
}

//
